const LOCALE_STORAGE_KEY = 'paygatex-lk-locale';

export type AuthErrorI18nKey =
  | 'errors.verificationFailed'
  | 'errors.emailAlreadyVerified'
  | 'errors.emailResendRateLimit';

export function resolveAuthErrorI18nKey(message: string | undefined): AuthErrorI18nKey | null {
  if (!message) {
    return 'errors.verificationFailed';
  }

  const normalized = message.toLowerCase();

  if (normalized.includes('already verify')) {
    return 'errors.emailAlreadyVerified';
  }

  if (normalized.includes('has limit')) {
    return 'errors.emailResendRateLimit';
  }

  return null;
}

export function isEmailAlreadyVerifiedError(message: string | undefined): boolean {
  return resolveAuthErrorI18nKey(message) === 'errors.emailAlreadyVerified';
}

export { LOCALE_STORAGE_KEY };
